export const enum AppURL {
    // eslint-disable-next-line no-unused-vars
    HELP = '/help',
}
